// extracted by mini-css-extract-plugin
export default {"tabs":"DynamicTabs-module_tabs__wCn9B","tab_panel":"DynamicTabs-module_tab_panel__Guc29"};